import {Component, OnInit, Renderer2} from '@angular/core';
import {Router} from '@angular/router';
import {ToastService} from './services/toast.service';
import {TokenService} from './services/token.service';
import {ActivityService} from './services/activity.service';
import {ThemeMode, ThemeService} from './services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  isLoggedIn: boolean;
  homeRoute: string[];
  isLoading: boolean;
  fullLogin: boolean;
  theme: ThemeMode;

  isMenuCollapsed: boolean = true;

  ngOnInit(): void {
    this.themeService.themeMode$.subscribe(m => this.theme = m);
    this.authService.isLoggedIn.subscribe(x => {
      this.homeRoute = x ? ['/', 'home'] : ['/'];
      this.isLoggedIn = x;
      this.fullLogin = false;

      if (this.isLoggedIn) {
        const jwt = this.authService.getUserToken();
        this.fullLogin = !(jwt && jwt.resetPassword);
      }
    });
    this.authService.init();
  }

  constructor(
    private themeService: ThemeService,
    public toastService: ToastService,
    private authService: TokenService,
    private activity: ActivityService) {
    this.activity.isLoading?.subscribe(x => {
      this.isLoading = x;
    });
  }

  toggleDarkMode(mode: ThemeMode) {
    this.themeService.setThemeMode(mode)
  }
}
